// Module
var code = " <div ng-show=\"SearchCtrl.hasFilter() && !inExcludes()\"> <button class=\"btn btn-danger btn-sm\" ng-click=\"SearchCtrl.cancelFilter(true, cancelTable, cancelTop)\"><i class=\"fa fa-times\"></i> {{'main.ZRUSIT_FILTER' | translate}}</button> <div class=\"searchbar separator\" ng-if=\"separator\"></div> </div>";
// Exports
module.exports = code;